import { Box } from '@mantine/core';
import LogoPrimary from '@/../public/Arcanis_Logo_Primary.png';
import Image from 'next/image';
import { ActionButton } from '@/shared/ActionButton';
import { SelectedPage } from '@/types/types';
import { ExternalLink } from 'lucide-react';

export const MobileTitleBox = () => {
  return (
    <Box className="flex h-auto w-full overflow-visible text-secondary-500 dark:text-lightBlue-200">
      <Box className="flex h-full w-full flex-col items-center justify-center gap-4">
        <Image
          priority
          src={LogoPrimary}
          alt="Arcanis Capital Logo"
          className="h-6 w-auto object-cover"
          quality={100}
        />
        <p
          className="text-center font-montserrat font-extrabold uppercase tracking-wide"
          style={{
            fontSize: 'calc(16px + 6vw)',
            lineHeight: '1.2',
            margin: '0',
          }}
        >
          SYSTEMATIC STRATEGIES <br /> FOR VENTURE INVESTING
        </p>
        <p className="mt-2  w-[70%] text-center font-semibold leading-snug tracking-wide text-secondary-500 md:text-2xl lg:text-2xl dark:text-lightBlue-500">
          <span className="font-semibold text-primary-500 text-2xl">
            Where data meets discipline in VC{' '}<br />
          </span>

        </p>
        <p className="px-4 mt-2 text-center font-medium leading-snug tracking-wide text-secondary-500 md:text-xl lg:text-xl dark:text-lightBlue-500">
          Arcanis Capital applies systematic, data-driven investment strategies to identify high-growth opportunities across global markets.
        </p>
      {/*   <p className="px-4 mt-2 text-center font-medium leading-snug tracking-wide text-secondary-500 md:text-xl lg:text-xl dark:text-lightBlue-500">
          Built on our proprietary analytics platform, every decision
          is backed by verifiable data, machine learning models,
          and repeatable methodology.
        </p> */}
        <div className="mt-8 space-x-3">
          {/* <ActionButton href={SelectedPage.ContactUs}>
            Schedule a call
          </ActionButton> */}
          <button onClick={() => window.location.href = '#systematicstrategiesforventureinvesting'} className='rounded-lg bg-gradient-to-r from-primary-500 to-primary-600 px-6 py-2 font-semibold text-gray-50 hover:from-primary-300 hover:to-primary-400 hover:text-gray-50'>
            Learn more
          </button>
          <button onClick={() => window.location.href = 'https://calendly.com/arcanis/arcanis-intro'} className='rounded-lg bg-gradient-to-r from-secondary-500 to-secondary-600 px-6 py-2 font-semibold text-gray-50 hover:from-secondary-300 hover:to-secondary-400 hover:text-gray-50'>
            Request a call
          </button>
        </div>
        <div className="flex gap-2 mt-2">
          <ExternalLink className="w-4" />
          <a href='https://arcanis.com' target="_blank" rel="noopener noreferrer" className="hover:text-primary-400 underline">
            Research Hub
          </a>
        </div>
      </Box>
    </Box>
  );
};
